// let url = 'http://api.cz.365mooc.cn/';  //线上
let url = 'http://api.zhxy.czvtc.edu.cn/';

//let url = "http://api.cz.com"    //线下
let Base64 = require('js-base64').Base64; 

export default {
  url, Base64, 
}
export const Link_Url =  {
homeurl:'http://www.miitbeian.gov.cn',
//池州学院
chischool:'http://www.czu.edu.cn/',
//庆职业技术学院
aqschool:'http://www.aqvtc.cn/',
//铜陵职业技术学院
tongschool:'http://www.tlpt.net.cn/',
//安徽职业技术学院
anhuischool:'http://www.uta.edu.cn/',

logoUrl:'http://www.zhxy.czvtc.edu.cn',   //logo

//登录
logo:'http://zsg.zhxy.czvtc.edu.cn/#/home/login',
// logo:'http://zsg.cz.365mooc.cn/#/home/login',
// logo:'http://localhost:8081/#/home/login',

}



// WEBPACK FOOTER //
// ./src/api/config.js